export default function EventCard({ event, onClick, onDelete, users = [] }) {

    const formatHeure = (heureISO) => {
        if (!heureISO) return null;
        return heureISO.substring(11, 16);
    };

    const heure = formatHeure(event.heureDebut);

    // Les livreurs peuvent être des IRIs (strings) ou des objets
    // On résout le nom depuis la liste users si ce sont des IRIs
    const resolvedLivreurs = (event.livreurs || []).map(l => {
        if (typeof l === 'string') {
            // C'est une IRI : chercher dans users
            const found = users.find(u => u['@id'] === l || `/api/users/${u.id}` === l);
            return found ? { nom: found.nom || found.email, iri: l } : null;
        }
        // C'est un objet
        return { nom: l.nom || l.email, iri: l['@id'] };
    }).filter(Boolean);

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        onDelete && onDelete(event);
    };

    return (
        <div
            onClick={() => onClick && onClick(event)}
            style={{
                position: 'relative',
                backgroundColor: '#f0f9ff',
                border: '1px solid #bae6fd',
                borderLeft: '3px solid #0ea5e9',
                borderRadius: '6px',
                padding: '5px 8px',
                marginBottom: '4px',
                cursor: 'pointer',
                transition: 'background-color 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e0f2fe'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0f9ff'}
        >
            <div onClick={handleDeleteClick} title="Supprimer l'événement"
                 style={{ position: 'absolute', top: '3px', right: '4px', fontSize: '11px', color: '#94a3b8', cursor: 'pointer', lineHeight: 1, padding: '1px 3px', borderRadius: '3px' }}
                 onMouseEnter={e => { e.stopPropagation(); e.currentTarget.style.color = '#ef4444'; }}
                 onMouseLeave={e => { e.stopPropagation(); e.currentTarget.style.color = '#94a3b8'; }}
            >×</div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingRight: '14px' }}>
                <span style={{ fontSize: '11px', flexShrink: 0 }}>📅</span>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#0369a1', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {event.titre}
                </span>
            </div>

            {(heure || event.description || resolvedLivreurs.length > 0) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '3px', paddingLeft: '16px' }}>
                    {heure && (
                        <span style={{ fontSize: '10px', color: '#7dd3fc', flexShrink: 0 }}>{heure}</span>
                    )}
                    {event.description && (
                        <span style={{ fontSize: '11px', color: '#64748b', fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                            {event.description}
                        </span>
                    )}
                    {!event.description && <span style={{ flex: 1 }} />}
                    {resolvedLivreurs.length > 0 && (
                        <div style={{ display: 'flex', gap: '2px', flexShrink: 0 }}>
                            {resolvedLivreurs.map(l => (
                                <span key={l.iri} style={{ fontSize: '9px', fontWeight: '700', color: '#0369a1', backgroundColor: '#bae6fd', padding: '1px 5px', borderRadius: '3px' }}>
                                    {l.nom.split(' ')[0]}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
